module.exports = __webpack_public_path__ + "src/assets/img/car_open-doors.0176b7ef.png";